module.exports = __webpack_public_path__ + "img/gzshzgzc_position_img.d514842c.png";